<script lang="ts">
  import AdminView from "./AdminView.svelte";
  import PageInsightsBlock from "./Block.svelte";
  import type { PageInsights } from "@/src/types/components/PageInsights";

  export let props: PageInsights;
  export let adminView: boolean = false;
  export let methodology: boolean = false;
  export let methodologyText: string = "";
  export let recentChanges: boolean = false;
  export let recentChangesList: string[] = [];
  export let crm: boolean = false;
  export let crmText: string = "";
</script>

{#if adminView}
  <AdminView {props} />
{:else}
  <PageInsightsBlock {props} {methodology} {methodologyText} {recentChanges} {recentChangesList} {crm} {crmText} />
{/if}
